import { useCallback } from "react";

import AuthenticationTwoFactorChallengeForm from "./TwoFactor/AuthenticationTwoFactorChallengeForm";

import { submitTwoFactorCode } from "../../mutations/SubmitTwoFactorCodeMutation";
import { resendTwoFactorCode } from "../../mutations/ResendTwoFactorCodeMutation";

// Second SMS two-factor step: enter the code sent by SMS. The user is signed in only
// once the code is verified.
const AuthenticationTwoFactorChallenge = ({ onSignIn }) => {
  const submitChallengeCode = useCallback(async formState => {
    const { submitTwoFactorCode: result } = await submitTwoFactorCode(formState);

    return result;
  }, []);

  const resendChallengeCode = useCallback(async () => {
    const { resendTwoFactorCode: result } = await resendTwoFactorCode();

    return result;
  }, []);

  return (
    <AuthenticationTwoFactorChallengeForm
      submitChallengeCode={submitChallengeCode}
      onConfirmed={onSignIn}
      resendChallengeCode={resendChallengeCode}
    />
  );
};

export default AuthenticationTwoFactorChallenge;
